import React, { Component } from 'react'; 
import {Row, Col, Button, InputGroup, Modal} from 'react-bootstrap';
import _ from "lodash";
import RegionalData from './RegionalData';

class ClientManagement extends Component {
  constructor(props){
    super(props)
    this.state={          
      region : _.cloneDeep(props.edit),
      mobileNumber:props.edit ? _.cloneDeep(props.edit.mobileNumber) : '',
      email:props.edit ? _.cloneDeep(props.edit.email) : '',
      emailIsValid:true
     
    }
  } 
 
  finalCallBack = (index, a) =>{    
    const{region} = this.state
    let temp = _.cloneDeep(region)
    temp.clientRegions[index] = a;
    this.setState({region:temp}) 
 
  }
  saveJSon = () => {
    if(this.state.emailIsValid ){
    this.props.action.editClient(this.state.region)
    this.props.closeModal()
    }
  }
  renderBody = (clientRegions) => {
    let UI = _.map(clientRegions, (obj, index)=>{
      return(<div><RegionalData data={_.cloneDeep(obj)} onFunction={(a) =>this.finalCallBack(index, a)} 
      reportlist={this.props.reportlist} freqlist={this.props.freqlist} /> </div>)
    })
    return UI 
  }

  handleChange = (e) =>{
    let region = _.cloneDeep(this.state.region)
    this.setState({[e.target.id]:e.target.value})   
    region[e.target.id] = e.target.value
    this.setState({region})
  }
  isValidEmailAddress = (address) =>{
    if(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(address)){
      return true
    } else {
      return false
    }
  }

  render(){
    const{edit} = this.props;
    return(
      <div>       
      <Modal
      show={true}
      onHide={this.props.closeModal}
      dialogClassName="modal-120w clientrecordxl"
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      >
      <Modal.Header closeButton>
      <Modal.Title id="example-custom-modal-styling-title">
      Client Details Record
      </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className ='client-Management'>      
          <Row>
          <Col md={4}>Client Name</Col>
          <Col md={6}><InputGroup><InputGroup.Prepend>
                <InputGroup.Text id="basic-addon1"><i class="fas fa-user-tag"></i></InputGroup.Text>
                </InputGroup.Prepend><input className='form-control' id='clientName' value={edit.inventoryClientName} 
                disabled type='text'/></InputGroup></Col>
          <Col md={2} />
          </Row>
          <Row>
          <Col md={4}>Client Contact Number</Col>
          <Col md={6}><InputGroup><InputGroup.Prepend>
                <InputGroup.Text id="basic-addon1"><i class="fas fa-user-tag"></i></InputGroup.Text>
                </InputGroup.Prepend><input className='form-control' id='mobileNumber' 
                value={this.state.mobileNumber} onChange={this.handleChange}
                 type='number'/></InputGroup></Col>
          <Col md={2} />
          </Row>
          <Row>
          <Col md={4}>Client Email</Col>
          <Col md={6}><InputGroup>          
          <InputGroup.Prepend>
                <InputGroup.Text id="basic-addon1"><i class="fas fa-user-tag"></i></InputGroup.Text>
                </InputGroup.Prepend><input className='form-control' id='email' 
                  value={this.state.email} onChange={this.handleChange}
                  required="true"
                  onBlur={() => this.setState({
                    emailIsValid: this.isValidEmailAddress(this.state.email)
                  }) }
                 type='email'/> 
                 </InputGroup>
                 {(this.state.emailIsValid === false) ? <span className="RedColoring">&nbsp;****Enter valid email****</span>: null}
                 </Col>
          <Col md={2} />
          </Row>
            {this.renderBody(edit.clientRegions)}         
       </div>
        <Button className='buttonwidth' onClick={this.saveJSon} block>SAVE</Button>        
          </Modal.Body>
          </Modal>
       
      </div>
      );
  }

}

export default ClientManagement

